import useApiCall from '../api/useApiCall'
import { getMyAccount } from '../api/users'

export interface ICapabilities {
    canDeleteFaq: boolean
}

const placeholderCapabilities: ICapabilities = {
    canDeleteFaq: false,
}

export const useCapabilities = (): ICapabilities => {
    const [{ data, loading }] = useApiCall(getMyAccount)

    if (loading || !data) {
        return placeholderCapabilities
    }

    return {
        canDeleteFaq: data.capabilities.can_delete_faq,
    }
}
